import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const IMG =
  "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvciUyMGxlYXRoZXIlMjBkZXRhaWx8ZW58MHx8fHwxNzg3Mzc4NjA2fDA&ixlib=rb-4.1.0&q=85";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 1, ease: [0.16, 1, 0.3, 1] },
};

export default function FinalInvitation() {
  return (
    <section
      data-testid="final-booking-section"
      className="relative overflow-hidden bg-near-black text-warm-white"
    >
      <div className="absolute inset-0">
        <img
          src={IMG}
          alt="Luxury vehicle interior detail"
          className="w-full h-full object-cover opacity-40"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-near-black/80 via-near-black/85 to-near-black" />
      </div>

      <div className="relative z-10 max-w-[92rem] mx-auto px-6 lg:px-12 py-32 md:py-48">
        <motion.div {...fadeUp} className="max-w-3xl">
          <p className="sjc-eyebrow text-gold flex items-center gap-4">
            <span className="sjc-hairline w-10" />
            The Concierge Desk
          </p>
          <h2 className="font-display mt-8 text-5xl md:text-6xl lg:text-[80px] leading-[1.02] tracking-[-0.02em]">
            Your journey,
            <br />
            <span className="italic font-light"> precisely handled.</span>
          </h2>
          <p className="mt-8 text-warm-white/70 text-base md:text-lg leading-relaxed font-light max-w-xl">
            Reserve online in a few quiet steps, or speak directly with our concierge team —
            available around the clock.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-start sm:items-center gap-8">
            <Link
              to="/book"
              data-testid="final-booking-cta"
              className="group inline-flex items-center gap-3 bg-warm-white text-midnight px-8 py-4 text-[11px] tracking-[0.28em] uppercase font-semibold transition-all duration-500 hover:bg-gold"
            >
              <span>Book Your Journey</span>
              <span className="w-2 h-2 rounded-full bg-midnight transition-transform duration-500 group-hover:translate-x-1" />
            </Link>
            <a
              href="tel:+61400000000"
              data-testid="final-booking-phone"
              className="group flex items-center gap-4 text-warm-white/85 hover:text-warm-white transition-colors duration-300"
            >
              <span className="w-8 h-px bg-gold transition-all duration-500 group-hover:w-12" />
              <div>
                <p className="sjc-eyebrow text-warm-white/60">Speak to us</p>
                <p className="mt-1 font-display text-xl md:text-2xl tracking-tight">
                  +61 400 000 000
                </p>
              </div>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
